const residentialLandUses = new Set([
    '03/A', '03/B', '03/C', '03/D', '03/G', '03/K', '03/L', '03/M', '03/N', '03/O', '03/P',
    '17/A', '17/B', '17/C',
]);

export default function isResidentialTravelPlan(landUse: string, subUse: string) {
    return residentialLandUses.has(`${landUse}/${subUse}`);
}
